import { memo } from 'react';
import { FiSend } from 'react-icons/fi';

const CommentInput = ({ value, onChange, onSubmit, replyingTo, handleReply, setReplyingTo, isSubmitting }) => {
	return (
		<div className="p-4 bg-stone-50 border-t border-stone-200">
			{replyingTo && (
				<div className="flex items-center justify-between mb-2 px-2 py-1 bg-amber-50 rounded-lg border border-amber-200">
					<p className="text-[11px] text-amber-700 font-semibold">
						Replying to <span className="font-bold">@{replyingTo.user?.fullName}</span>
					</p>
					<button onClick={() => setReplyingTo(null)} className="text-amber-600 hover:text-amber-800">
						<svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M6 18L18 6M6 6l12 12" />
						</svg>
					</button>
				</div>
			)}

			<div
				className="
					flex items-end gap-2 rounded-[22px] px-4 py-2
					bg-stone-100/80
					border border-transparent
					transition-all duration-300

					focus-within:bg-stone-100
					focus-within:border-amber-500
					focus-within:shadow-[0_0_0_3px_rgba(245,158,11,0.15)]
				"
			>
				{/* Textarea */}
				<textarea
					rows={1}
					placeholder={
						isSubmitting
							? replyingTo
								? "Adding reply..."
								: "Posting comment..."
							: replyingTo
								? "Write a reply..."
								: "Add a comment..."
					}
					value={value}
					disabled={isSubmitting}
					onChange={onChange}
					onKeyDown={(e) => {
						if (e.key === "Enter" && !e.shiftKey) {
							e.preventDefault();
							replyingTo ? handleReply() : onSubmit();
						}
					}}
					className="
						flex-1 py-2 text-sm bg-transparent resize-none max-h-32
						text-stone-700 placeholder:text-stone-500 font-medium leading-tight
						border-none outline-none ring-0 shadow-none appearance-none
					"
				/>

				{/* Send Button */}
				<div className="shrink-0 flex items-center justify-center">
					<button
						onClick={replyingTo ? handleReply : onSubmit}
						disabled={!value.trim() || isSubmitting}
						className={`
							group flex items-center justify-center w-10 h-10 rounded-full
							outline-none ring-0 appearance-none
							transition-all duration-300
							${value.trim()
								? "bg-amber-600 text-white shadow-lg shadow-amber-500/30 active:scale-90"
								: "bg-transparent text-stone-400 scale-90 opacity-50 cursor-not-allowed"
							}
						`}
					>
						<FiSend
							size={18}
							className={`transition-transform duration-300 ${value.trim()
								? "group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
								: ""
								}`}
						/>
					</button>
				</div>
			</div>

		</div>
	)
}

export default memo(CommentInput);